import api from './apiLibrary';

const API = {
    getSubscriptions() {
        return api.get('/api/webhooks/subscriptions');
    },
    getSubscription(id) {
        return api.get(`/api/webhooks/subscriptions/${id}`);
    },
    createSubscription(data) {
        return api.post('/api/webhooks/subscriptions', data);
    },
    updateSubscription(id, data) {
        return api.patch(`/api/webhooks/subscriptions/${id}`, data);
    },
    rotateSecret(id) {
        return api.post(`/api/webhooks/subscriptions/${id}/rotate-secret`);
    },
    deleteSubscription(id) {
        return api.delete(`/api/webhooks/subscriptions/${id}`);
    },
    sendTest(id) {
        return api.post(`/api/webhooks/subscriptions/${id}/test`);
    },
    getDeliveries(params) {
        return api.get('/api/webhooks/deliveries', params);
    },
    retryDelivery(id) {
        return api.post(`/api/webhooks/deliveries/${id}/retry`);
    },
};

export default API;
